// extracted by css-extract-rspack-plugin
export default {"AddCommentEditor":"AddCommentEditor-module__AddCommentEditor__wLtyg"};